import React from "react";
import { FiChevronRight } from "react-icons/fi";
import "./Breadcrumb.css";

interface BreadcrumbItem {
  label: string;
  onClick?: () => void;
  disabled?: boolean;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  const IconComponent = FiChevronRight as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >;
  return (
    <div className="breadcrumb-container">
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <div className="breadcrumb-item">
            {item.disabled || !item.onClick ? (
              <span className="breadcrumb-disabled">{item.label}</span>
            ) : (
              <button className="breadcrumb-clickable" onClick={item.onClick}>
                {item.label}
              </button>
            )}
          </div>
          {index < items.length - 1 && (
            <IconComponent className="breadcrumb-separator" />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Breadcrumb;
